export default {
  title: 'Betaling',
  description: 'Alle transaktioner er sikre og krypterede',
  show_more_payment_methods: 'Vis flere betalingsmetoder',
  express_checkout_divider: 'eller',
};
